import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { SchoolService } from "../../../../shared/services/school.service";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { DataService_ViewSection } from "../shared/data.service";

@Component({
	selector: "caass-section-selector",
	templateUrl: "./section-selector.component.html",
	styleUrls: ["./section-selector.component.css"],
})
export class SectionSelectorComponent implements OnInit {
	constructor(private selectService: SchoolselectorService, private SchoolService: SchoolService, private ViewSectionService: DataService_ViewSection) {}

	ngOnInit(): void {
		// this.loadSchools();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	///////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////

	subscription: any;

	@Output() SectionSelected: EventEmitter<any> = new EventEmitter();

	//Input Data
	SchoolID: any = 0;
	lstSchool: any = [];

	SemesterID: any = 0;
	lstSemesters: any = [];

	//Table Data

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSection: any;
	lstSection: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "CourseNo", header: "Section" },
		{ field: "CourseCD", header: "Description" },
		{ field: "InstructorDesc", header: "Instructor" },
	];

	///////////////

	///////////////////////////////////////////////

	///////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////

	loadSchools() {
		var result = this.SchoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				this.SchoolID = this.lstSchool[0].SchoolID;

				this.loadSemesters();
			},
			(error) => {}
		);
	}

	loadSemesters() {
		var result = this.ViewSectionService.LoadSemesters(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstSemesters = response;

				this.SemesterID = this.lstSemesters[0].SemesterID;

				this.loadSection();
			},
			(error) => {}
		);
	}

	loadSection() {
		this.loading = true;

		var result = this.ViewSectionService.LoadSection(this.SemesterID, this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstSection = response;

				// for(var i = 0; i < this.lstSection.length; i++){
				//   var next = this.lstSection[i];

				//   next.InstructorDesc = next.FirstName + " " + next.LastName;
				// }

				this.loading = false;
			},
			(error) => {}
		);
	}

	///////////////////////////////////////////////

	///////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////

	onSchoolChange(val) {
		this.SchoolID = val;

		this.loadSemesters();
	}

	onSemesterChange(val) {
		this.SemesterID = val;

		this.loadSection();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSection = val.data;

		this.SelectedSection.SemesterID = this.SemesterID; //Pass back semester

		this.SectionSelected.emit(this.SelectedSection);
	}
	onRowUnselect(val) {
		this.SelectedSection = null;

		this.SectionSelected.emit(this.SelectedSection);
	}

	///////////////////////////////////////////////
}
